import React from "react";
// @ts-ignore
import { useLingui } from "@lingui/react";
import { t } from "@lingui/macro";
import { styled, fonts, black, white, pink } from "../../../styles";

export interface ProjectSearchProps {
  searchTerm?: string;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  searchOpen: boolean;
  toggleSearch: () => void;
}

export const ProjectSearch: React.FC<ProjectSearchProps> = ({
  searchTerm,
  onChange,
  searchOpen,
  toggleSearch
}) => {
  const { i18n } = useLingui();

  return (
    <ProjectSearchContainer
      className={searchOpen ? "work__search--open" : undefined}
      onSubmit={e => {
        e.preventDefault();
      }}
    >
      <ProjectSearchInput
        type="search"
        placeholder={i18n._(t`Projekte durchsuchen`)}
        aria-label="Search"
        size={5}
        id="work-search"
        value={searchTerm}
        onChange={onChange}
        className={searchOpen ? "work__search--open" : undefined}
      />

      <ProjectSearchIcon
        as="label"
        htmlFor="work-search"
        onClick={toggleSearch}
        className={searchOpen ? "active" : undefined}
      >
        |
      </ProjectSearchIcon>
    </ProjectSearchContainer>
  );
};

const ProjectSearchContainer = styled.form`
  z-index: 199;
/*  background-color: ${white}; */

  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 2px;

  border-bottom: 1px solid transparent;

  height: 30px;

  width: 100%;
  flex: 1;
  max-width: 100px;

  position: absolute;
  right: -20px;

  &.work__search--open {
    border-bottom: 1px solid ${black};
    min-width: 215px;
    max-width: 215px;
  }

  /* always open */
  @media (min-width: 475px) {
    border-bottom: 1px solid ${black};
    min-width: 215px;
    max-width: 215px;
    right: 0;
  }

`;

const ProjectSearchInput = styled.input`
  height: 100%;
  border-bottom: none;
  padding-right: 0;
  display: none;

  flex: 1;

  &:focus + label,
  &:active + label {
    animation: wahnsinn 0.3s linear 0s infinite;
    color: ${pink};
  }

  @media (min-width: 475px) {
    display: initial;
  }

  &.work__search--open {
    display: initial;

    + label {
      animation: wahnsinn 0.3s linear 0s infinite;
      color: ${pink};
    }
  }
`;

const ProjectSearchIcon = styled.label`
  font-size: 2rem;
  min-width: 2rem;
  flex: 0;
  cursor: pointer;
  user-select: none;

  height: 100%;
  width: 30px;

  font-family: ${fonts.vario};
  font-size: 28px;

  text-transform: uppercase;
  font-variation-settings: "wght" 520;

  display: flex;
  align-items: center;
  justify-content: center;

  align-self: flex-end;

  margin-left: auto;

  @media (min-width: 475px) {
    pointer-events: none;
  }
`;
